// Shared site navigation markup (BRIEF §5 static pages). Used by main.ts (the tool page) and
// duplicated as static HTML in the other pages (so-funktionierts.html, datenschutz.html,
// impressum.html) — those are plain static content with no interactivity, so they don't load
// this module; keeping the markup here documents the canonical structure/labels once.

export type SitePage = 'start' | 'so-funktionierts' | 'datenschutz' | 'impressum';

const LINKS: { page: SitePage; href: string; label: string }[] = [
  { page: 'start', href: '/', label: 'Start' },
  { page: 'so-funktionierts', href: '/so-funktionierts.html', label: 'So funktioniert’s' },
  { page: 'datenschutz', href: '/datenschutz.html', label: 'Datenschutz' },
  { page: 'impressum', href: '/impressum.html', label: 'Impressum' },
];

export function siteNavHtml(active: SitePage): string {
  const items = LINKS.map(
    (l) =>
      `<a href="${l.href}" class="site-nav__link"${l.page === active ? ' aria-current="page"' : ''}>${l.label}</a>`,
  ).join('');
  return `<nav class="site-nav" aria-label="Hauptnavigation">${items}</nav>`;
}
